import { render, staticRenderFns } from "./FileTagList.vue?vue&type=template&id=360a8029&"
import script from "./FileTagList.vue?vue&type=script&lang=ts&"
export * from "./FileTagList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports